import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Pagination from "react-js-pagination";

import useQueryString from "../../../../hooks/useQueryString";
import { findTargetMenuName } from "../../common/function/shopping";
import { SectionContainer, ListContainer } from "../../productList/component/styled";
import { FaBars } from "react-icons/fa6";
import Portfolio from "./portfolio";

const PortfolioList = () => {
  const navigater = useNavigate();
  const queryPage = Number(useQueryString("page"));

  const [isLoading, setIsLoading] = useState(true);
  const [portfolio, setPortfolio] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const { cmpnyNo, url, menus, theme } = useOutletContext();
  const [currentPage, setCurrentPage] = useState(queryPage || 0);

  const apiUrl = "/api/portMgmtList";

  useEffect(() => {
    if (cmpnyNo) {
      getPortfolio();
    } else {
      setIsLoading(false);
    }
  }, [cmpnyNo]);

  useEffect(() => {
    navigater(`/shop/${url}/portfolio?page=${currentPage}`);
  }, [currentPage]);

  const getPortfolio = async (page = queryPage || 0) => {
    setCurrentPage(page);
    const body = {
      cmpnyNo,
      useYn: "Y",
      notitleYn: "Y",
      offset: 12 * page,
      pageNumber: page,
      pageSize: 12,
      paged: true,
    };
    const response = await axios.post(apiUrl, body);
    const res = response.data.content;
    setIsLoading(false);
    setPortfolio(res);
    setTotalCount(response?.data?.totalElements);
  };

  const nextPage = (num) => {
    getPortfolio(num - 1);
  };

  return (
    <SectionContainer className={`theme-${theme}`}>
      <h3>
        <span>{findTargetMenuName(menus, 2)}</span>
      </h3>
      <div className="count">
        <FaBars />
        포트폴리오
        <strong> {totalCount}</strong>
        개가 등록되어 있습니다.
      </div>
      <ListContainer className={`product theme-${theme}`}>
        {portfolio.map((item) => (
          <Portfolio item={item} url={url} currentPage={currentPage} />
        ))}
      </ListContainer>
      <Pagination
        activePage={currentPage + 1}
        itemsCountPerPage={12}
        totalItemsCount={totalCount}
        pageRangeDisplayed={3}
        prevPageText={"‹"}
        nextPageText={"›"}
        onChange={nextPage}
      />
    </SectionContainer>
  );
};

export default PortfolioList;
